import * as yup from "yup";
import { CountryOption } from "../../../../../../components/PhoneNumberCountryCodeSelector/utils/types";
import {
  validatePhoneNumber,
  findCountryByCode,
  transformCountryOptions,
} from "../../../../../../components/PhoneNumberCountryCodeSelector/utils/phoneNumberUtils";
import { getRegionFlag } from "../../../../../../utils/constants/regionDefaultCallingCodes";
import { countryOptions } from "../../../../../../utils/constants/countryOptions";
import { ALL_PROPERTIES_ACCESS_SENTINEL } from "../../EditUserDrawer/utils/verbaiqCategories.constants";

const transformedCountryOptions = transformCountryOptions(countryOptions);

export const getUserDetailsInitialValues = (region?: string) => ({
  name: "",
  email: "",
  phoneCountryCode:
    findCountryByCode(getRegionFlag(region), transformedCountryOptions) ||
    transformedCountryOptions[0],
  phoneNumber: "",
  isAgent: false,
  isInternationalAgent: false,
  organizations: [],
});

export const userDetailsInitialValues = getUserDetailsInitialValues();

export const userDetailsValidationSchema =  
  yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().required("Email is required").email("Invalid email"),
    phoneCountryCode: yup.object().required("Phone country code is required"),
    phoneNumber: yup.string().when("phoneCountryCode", {
      is: (phoneCountryCode: CountryOption | null) => phoneCountryCode !== null,
      then: () =>
        yup
          .string()
          .required("Phone number is required")
          .test(
            "valid-phone",
            "Please enter a valid phone number",
            (value, context) => {
              if (!value) return false;

              const phoneCountryCode = context.parent.phoneCountryCode;
              if (!phoneCountryCode) return false;

              const phoneData = validatePhoneNumber(value, phoneCountryCode);
              return phoneData?.isValid;
            }
          ),
      otherwise: (schema: yup.StringSchema) => schema,
    }),
    isAgent: yup.boolean(),
    isInternationalAgent: yup.boolean(),
  });


export const assignRoleInitialValues = {
  role: "",
  country_ids: [],
  city_ids: [],
  // New users default to unrestricted property access (the all-properties sentinel), narrowed
  // down by an admin if needed — matches UserModel.property_ids' backend default exactly.
  property_ids: [ALL_PROPERTIES_ACCESS_SENTINEL],
};

export const assignRoleValidationSchema = yup.object().shape({
  role: yup.string().required("Role is required"),
});

export const agentDetailsInitialValues = {
  start_shift: "",
  end_shift: "",
  // weekdays: [],
  velocity: 0,
  daily_assignment_limit: 0,
  max_score: 0,
  min_score: 0,
  selected_lead_ranges: [],
  student_only: false,
  working_professionals: false,
  country_whitelist: [],
  country_blacklist: [],
  city_whitelist: [],
  city_blacklist: [],
  utm_source_whitelist: [],
  utm_source_blacklist: [],
  utm_medium_whitelist: [],
  utm_medium_blacklist: [],
};

export const agentDetailsValidationSchema = yup.object().shape({
  velocity: yup
    .number()
    .required("Velocity is required")
    .min(1, "Velocity must be between 1 and 10")
    .max(10, "Velocity must be between 1 and 10"),
  start_shift: yup
    .string()
    .required("Start shift is required")
    .test(
      "is-before-end",
      "Start time must be before end time",
      function (value) {
        const { end_shift } = this.parent;
        if (!value || !end_shift) return true;
        return value < end_shift;
      }
    ),
  end_shift: yup
    .string()
    .required("End shift is required")
    .test(
      "is-after-start",
      "End time must be after start time",
      function (value) {
        const { start_shift } = this.parent;
        if (!value || !start_shift) return true;
        return value > start_shift;
      }
    ),
  daily_assignment_limit: yup
    .number()
    .required("Daily assignment limit is required")
    .min(1, "Daily assignment limit must be between 1 and 1000")
    .max(1000, "Daily assignment limit must be between 1 and 1000"),
  // selected_lead_ranges: yup
  //   .array()
  //   .min(1, "Select at least one lead score range"),
});

export const USER_INFO_TABS = [
  {
    id: "roles_and_permissions",
    label: "Roles & Permissions",
  },
  {
    id: "organisations",
    label: "Organisations",
  },
];
